import React, { FC } from 'react'
import { useHistory } from 'react-router'

import { routes } from 'constants/routes'
import Dropdown from 'components/Dropdown'

import {
  MenuWrapper,
  ProjectsMenuWrapper,
  StyledPill,
  WorkspaceSelectorWrapper,
} from './ProjectsMenu.styles'

import { icons } from './icons'
import { menuItemsText } from './ProjectsMenu'

import {
  NoWorkspacesAvatar,
  NoWorkspacesDropdown,
  NoWorkspacesIcon,
  NoWorkspacesTitle,
} from './NoWorkspaceProjectsMenu.styles'

import { useGetInitialUserQuery } from 'gqlTypes'
import HelpMenu from './HelpMenu'

import { LinkItem } from '../Item'

export const NoWorkspaceProjectsMenu: FC<{}> = () => {
  const history = useHistory()

  const { data: userData } = useGetInitialUserQuery()
  const showUnseenNotificationBadge =
    userData?.me.hasUnseenNotifications ?? false

  return (
    <ProjectsMenuWrapper>
      <WorkspaceSelectorWrapper>
        <NoWorkspacesDropdown
          onClick={() => history.push(routes.WORKSPACE_CREATE.create({}))}>
          <NoWorkspacesAvatar />
          <NoWorkspacesTitle>No Workspaces</NoWorkspacesTitle>
          <NoWorkspacesIcon>
            <Dropdown.Chevrons />
          </NoWorkspacesIcon>
        </NoWorkspacesDropdown>
      </WorkspaceSelectorWrapper>
      <MenuWrapper>
        <LinkItem
          icon={icons.PersonIcon}
          text={menuItemsText.account}
          to={routes.PERSONAL_SETTINGS.create({})}
        />
        <LinkItem
          icon={icons.BellIcon}
          text={menuItemsText.updates}
          to={routes.UPDATES.create({})}
          additional={
            showUnseenNotificationBadge && (
              <StyledPill variant={{ kind: 'secondary' }}>New</StyledPill>
            )
          }
        />
      </MenuWrapper>
      <HelpMenu />
    </ProjectsMenuWrapper>
  )
}
